import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { MyContext } from '../Context/MyContext';
import { isNearLocationFeatureEnabled } from '../utils/nearLocationConfig';

/** Redirects to home when the nearby location feature is disabled in admin. */
const NearbyLocationRoute = ({ children }) => {
  const { nearLocationConfig } = useContext(MyContext);
  if (!isNearLocationFeatureEnabled(nearLocationConfig)) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default NearbyLocationRoute;
